import {useEffect, useState} from 'react';

export function ScrollToLoadMore({
    onLoadMore,
    pagePercent, // page scroll percent to trigger load more
    isHasMore,
    isLoading,
}: Readonly<{
    onLoadMore: () => void;
    pagePercent: number;
    isHasMore: boolean;
    isLoading: boolean;
}>) {
    const [isFetchMore, setIsFetchMore] = useState<boolean>(false);

    const handleScrollDownToLoadMore = () => {
        if (isFetchMore) return;

        if (
            window.innerHeight + document.documentElement.scrollTop >
            (pagePercent / 100) * document.scrollingElement?.scrollHeight!
        ) {
            window.removeEventListener('scroll', handleScrollDownToLoadMore);
            setIsFetchMore(true);
        }
    };

    useEffect(() => {
        if (isFetchMore) {
            onLoadMore();
            setIsFetchMore(false);
        }
    }, [isFetchMore]);

    useEffect(() => {
        if (!isFetchMore && !isLoading && isHasMore) {
            window.addEventListener('scroll', handleScrollDownToLoadMore);
        }

        return () => {
            window.removeEventListener('scroll', handleScrollDownToLoadMore);
        };
    }, [isFetchMore, isLoading, isHasMore]);

    return <></>;
}
